module.exports = __webpack_public_path__ + "img/CNY.29e6d895.png";